/// <amd-module name="Tfs/ReduxCommon/Modules/CommandViewAction/CommandViewActionActions" />
import { ActionsUnion, createAction } from "redux/Utils/ActionHelper";
import { CommandMap, ICommandTogglePayload } from "Tfs/ReduxCommon/Modules/CommandViewAction/CommandViewActionContracts";

export const enum CommandViewActionActionTypes {
    AddCommands = "CommandViewActionActionTypes/AddCommands",
    AddViewActions = "CommandViewActionActionTypes/AddViewActions",
    ToggleViewActionDisableState = "CommandViewActionActionTypes/ToggleViewActionDisableState",
    ToggleCommandDisableState = "CommandViewActionActionTypes/ToggleCommandDisableState"
}

export const CommandViewActionActions = {
    addCommands: (commands: CommandMap) => createAction(CommandViewActionActionTypes.AddCommands, commands),
    addViewActions: (viewActions: CommandMap) => createAction(CommandViewActionActionTypes.AddViewActions, viewActions),
    toggleViewActionDisableState: (viewActions: ICommandTogglePayload[]) =>
        createAction(CommandViewActionActionTypes.ToggleViewActionDisableState, viewActions),
    toggleCommandsDisableState: (commands: ICommandTogglePayload[]) => createAction(CommandViewActionActionTypes.ToggleCommandDisableState, commands)
};

export type CommandViewActionActions = ActionsUnion<typeof CommandViewActionActions>;
